var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.errors.length || Object.keys(_vm.errors).length
    ? _c(
        "div",
        { staticClass: "alert alert-danger", attrs: { role: "alert" } },
        [
          _c("strong", [_vm._v("The following error was found in your file:")]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm._l(_vm.errors, function (errorObject, index) {
            return _c("div", { key: index }, [
              errorObject instanceof Object && !(errorObject instanceof Array)
                ? _c(
                    "dl",
                    { staticClass: "dl-horizontal" },
                    _vm._l(errorObject, function (value, key, i) {
                      return _c("div", { key: i }, [
                        _c("dt", [_vm._v(_vm._s(key))]),
                        _vm._v(" "),
                        _c("dd", [_vm._v(_vm._s(value))]),
                      ])
                    }),
                    0
                  )
                : _c("div", [
                    _vm._v(
                      "\n            " + _vm._s(errorObject) + "\n        "
                    ),
                  ]),
            ])
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }